export enum ResultData {
	ReplaceSourceArray,
	OnlyKeepExtractedValue,
}
